import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/margin-vs-markup',
  component: () => import('../../routes/MarginVsMarkup.svelte'),
  card: {
    id: 'margin-vs-markup',
    title: 'Margin vs Markup',
    description:
      'Convert between profit margin and markup. See why these business metrics are not the same and avoid pricing mistakes.',
    icon: 'trending_up',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/margin-vs-markup',
    category: 'Business',
  },
  seo: {
    title: 'Margin vs Markup Calculator – Convert Profit Margin to Markup',
    description:
      'Free margin vs markup calculator to convert between profit margin and markup percentage. Learn why 50% margin is not the same as 50% markup, with examples and a price sensitivity table.',
  },
};

export default meta;
